import { useCallback, useState } from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { useGetTechnicalSupportRequestHistoryQuery } from '../../../../api/endpoints/technicalSupportRequest';

const useTechnicalSupportRequestHistoryData = () => {
    const { getCurrentLanguageId } = useLanguage();
    const [requestId, setRequestId] = useState(null);
    const openHistory = useCallback((request) => setRequestId(request.id), []);
    const closeHistory = useCallback(() => setRequestId(null), []);
    const { data, isFetching, isError } = useGetTechnicalSupportRequestHistoryQuery({ id: requestId, languageId: getCurrentLanguageId() }, { skip: requestId === null, refetchOnMountOrArgChange: true });

    return { requestId, history: Array.isArray(data) ? data : [], isFetching, isError, openHistory, closeHistory };
};

export default useTechnicalSupportRequestHistoryData;
